export const NGANHHANG_LIST_INITING             = 'NGANHHANG_LIST_INITING'
export const NGANHHANG_LIST_REQUESTING          = 'NGANHHANG_LIST_REQUESTING'
export const NGANHHANG_LIST_SUCCESS             = 'NGANHHANG_LIST_SUCCESS'
export const NGANHHANG_LIST_ERROR               = 'NGANHHANG_LIST_ERROR'   

export const NGANHHANG_DETAIL_INITING           = 'NGANHHANG_DETAIL_INITING'
export const NGANHHANG_DETAIL_REQUESTING        = 'NGANHHANG_DETAIL_REQUESTING'
export const NGANHHANG_DETAIL_SUCCESS           = 'NGANHHANG_DETAIL_SUCCESS'
export const NGANHHANG_DETAIL_ERROR             = 'NGANHHANG_DETAIL_ERROR'   

export const NGANHHANG_UPDATE_REQUESTING        = 'NGANHHANG_UPDATE_REQUESTING'
export const NGANHHANG_UPDATE_SUCCESS           = 'NGANHHANG_UPDATE_SUCCESS'
export const NGANHHANG_UPDATE_ERROR             = 'NGANHHANG_UPDATE_ERROR'   

export const NGANHHANG_DETAIL_API               = '/api/v1/management/nganhhang_detail_by_id'  
export const NGANHHANG_LIST_API                 = '/api/v1/management/nganhhang_list_by_store'   
export const NGANHHANG_UPDATE_API               = '/api/v1/management/nganhhang_update_by_id'  


// WEBPACK FOOTER //
// ./src/views/NganhHang/constants.js